import { useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

const ReleaseTracks = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraSoftwarePricingPageTemplate.features.ReleaseTracks.header",
            defaultMessage: "Release tracks"
        }),
        content: intl.formatMessage(
            {
                id: "JiraSoftwarePricingPageTemplate.features.ReleaseTracks.content",
                defaultMessage:
                    "Control when and how you release changes to users with release tracks. {br}{br} With options to control Atlassian cloud releases, release tracks make your daily management of our cloud products more predictable. This helps you plan, prepare, and ensure success for upcoming product changes."
            },
            { ...DEFAULT_VALUES }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
        </>
    );
};

export default ReleaseTracks;
